export default __webpack_public_path__ + "static/summit_stars_4_2-b832005378a85d63f37142161355ba0e.svg";